import React from 'react';

export const LazyThreeDViewerPage = React.lazy(() => import('./ThreeDViewerPage'));
